<template>
  <v-autocomplete
    v-model="brandUUID"
    :class="{ 'pt-0': noStyle, 'mt-0': noStyle }"
    :items="brandOptions"
    item-value="uuid"
    item-text="name"
    :menu-props="{ maxHeight: '400' }"
    @input.native="loadBrands($event, $data)"
    :search-input.sync="brandSearch"
    :label="
      !isRequired
        ? $t('components.selectors.brandSelector.brand')
        : $t('components.selectors.brandSelector.brand') + '*'
    "
    :persistent-hint="!isRequired"
    color="primary"
    clearable
    multiple
    chips
    deletable-chips
    :hint="!isRequired ? '' : $t('components.selectors.brandSelector.required')"
    hide-selected
    :disabled="disabled"
    :rules="!isRequired ? [] : [requiredRule]"
    autocomplete="off"
    :prepend-icon="prependIcon"
  >
    <template v-slot:item="{ item }">
      <span class="mr-2">
        {{ item.name }}
      </span>
      <span>
        <v-chip outlined>{{ getGroupType(item) }}</v-chip>
      </span>
    </template>
  </v-autocomplete>
</template>
<script>
import api from "@/utils/api";
import debounce from "@/plugins/debounce";

export default {
  name: "BrandSelector",
  props: [
    "brandUuid",
    "initialData",
    "disabled",
    "required",
    "multiple",
    "selectAll",
    "prependIcon",
    "noStyle",
    "queryParameters",
  ],
  data: () => ({
    brandOptions: [],
    brandSearch: "",
  }),
  created() {
    if (this.selectAll) {
      this.loadBrands().then((resp) => {
        this.brandUUID = [...this.brandOptions.map((item) => item.uuid)];
      });
      return;
    }
    if (this.multiple && this.initialData.length !== 0) {
      this.loadBrands().then((resp) => {
        this.brandUUID = [...this.initialData];
      });
      return;
    }
    if (this.initialData && typeof this.initialData.uuid !== "undefined") {
      this.brandOptions.push(this.initialData);
      this.brandUUID = this.initialData.uuid;
    }
    this.loadBrands(null, this);
  },
  computed: {
    isRequired() {
      return !!this.required;
    },
    brandLabel: function () {
      return this.label;
    },
    brandUUID: {
      get: function () {
        return this.brandUuid;
      },
      set: function (value) {
        this.$emit("update:brandUuid", value);
        this.$emit("change", value);
      },
    },
  },
  methods: {
    getGroupType(item) {
      if (item.is_supergroup)
        return this.$t("components.selectors.brandSelector.organization");
      if (item.is_range)
        return this.$t("components.selectors.brandSelector.range");

      return this.$t("components.selectors.brandSelector.brand");
    },
    requiredRule(value) {
      if (value instanceof Array && value.length == 0) {
        return this.$t("components.selectors.brandSelector.brandIsRequired");
      }
      return (
        !!value || this.$t("components.selectors.brandSelector.brandIsRequired")
      );
    },
    loadBrands: function () {
      return new Promise((resolve, reject) => {
        let self = this;
        self.brandSearch = self.brandSearch ? self.brandSearch : "";

        let params = {
          search: self.brandSearch,
          include_all_brands: true,
          exclude_supergroup: true,
          ...this.queryParameters,
        };

        if (this.$route.query.my_account === "true") {
          params = { ...params, partner_uuid: this.$route.params.id };
        }

        api.groupsAutocomplete(params).then((resp) => {
          resp.data.forEach((element) => {
            if (
              !self.brandOptions.find((el) => el.uuid === element.uuid) &&
              !element.is_supergroup
            ) {
              self.brandOptions.push(element);
            }
          });
          resolve();
        });
      });
    },
    debounceBrands: debounce((event, self) => {
      this.loadBrands();
    }, 300),
  },
};
</script>
